import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-white py-12 border-t-2 border-gray-200" data-id="element-165">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-166">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-167">
          <div data-id="element-168">
            <div className="mb-6" data-id="element-169">
              <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8" data-id="element-170" />
            </div>
            <ul className="space-y-3" data-id="element-171">
              <li data-id="element-172">
                <Link to="/" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-173">
                  Home
                </Link>
              </li>
              <li data-id="element-174">
                <Link to="/how-it-works" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-175">
                  How It Works
                </Link>
              </li>
              <li data-id="element-176">
                <Link to="/resources" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-177">
                  Resources
                </Link>
              </li>
              <li data-id="element-178">
                <Link to="/pricing" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-179">
                  Pricing
                </Link>
              </li>
              <li data-id="element-180">
                <Link to="/about-us" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-181">
                  About
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-182">
            <div className="text-lg font-bold text-[#111111] mb-6" data-id="element-183">For You</div>
            <ul className="space-y-3" data-id="element-184">
              <li data-id="element-185">
                <Link to="/individuals" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-186">
                  For Individuals
                </Link>
              </li>
              <li data-id="element-187">
                <Link to="/families" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-188">
                  For Families
                </Link>
              </li>
              <li data-id="element-189">
                <Link to="/intro-assessment" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-190">
                  Free Assessment
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-191">
            <div className="text-lg font-bold text-[#111111] mb-6" data-id="element-192">Legal</div>
            <ul className="space-y-3" data-id="element-193">
              <li data-id="element-194">
                <Link to="/privacy" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-195">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-196">
                <a href="/terms" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-197">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-198">
                <a href="/subscription" className="text-gray-600 hover:text-[#631bb7] no-underline transition-colors" data-id="element-199">
                  Subscription Terms
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-200">
            <div className="text-lg font-bold text-[#111111] mb-6" data-id="element-201">
              Disclaimer
            </div>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-202">
              Caveo as a family protection platform does not monitor private
              communications. Please consult with your family before making any
              safety decisions.
            </p>
          </div>
        </div>

        {/* Design Test Pages - Tucked Away */}
        <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-203">
          <details className="text-xs text-gray-400" data-id="element-204">
            <summary className="cursor-pointer hover:text-gray-500 transition-colors" data-id="element-205">
              Design System Tests
            </summary>
            <div className="mt-3 flex flex-wrap gap-4" data-id="element-206">
              <Link to="/test/button-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-207">
                Button Colors
              </Link>
              <Link to="/test/color-comparison" className="hover:text-[#631bb7] transition-colors" data-id="element-208">
                Color Comparison
              </Link>
              <Link to="/test/fonts" className="hover:text-[#631bb7] transition-colors" data-id="element-209">
                Font Test
              </Link>
              <Link to="/test/purple-colors" className="hover:text-[#631bb7] transition-colors" data-id="element-210">
                Purple Colors
              </Link>
              <Link to="/coming-soon" className="hover:text-[#631bb7] transition-colors" data-id="element-211">
                Coming Soon Page
              </Link>
            </div>
          </details>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center" data-id="element-212">
          <div className="mb-4 md:mb-0" data-id="element-213">
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-214" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-215" />
          </div>
          <div className="text-sm text-gray-500" data-id="element-216">
            © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}